/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { imagesGetApiV3ImagesSubnetsSubnetIdPng } from "../../funcs/imagesGetApiV3ImagesSubnetsSubnetIdPng.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetApiV3ImagesSubnetsSubnetIdPngRequest$inboundSchema,
};

export const tool$imagesGetApiV3ImagesSubnetsSubnetIdPng: ToolDefinition<
  typeof args
> = {
  name: "images-get-api-v3-images-subnets-subnet-id-png",
  description: ``,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await imagesGetApiV3ImagesSubnetsSubnetIdPng(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
